// src/config/seoConfig.js
import React from "react";

export const appName = "INTER TENNIS";
export const appDescription = "Boost your tennis skills with AI analytics using AR-powered 3D tracking.";
export const appUrl = "https://inter.tennis";
export const appImage = "https://inter.tennis/Logo_rect_tilted_128.png";

export const getSeoMetaTags = (pageTitle, pageDescription, pagePath = "", keywords = "tennis analytics, ai tennis coaching, AR tennis tracking, 3D tennis analysis, tennis stroke comparison, smart tennis app, tennis performance tracking, inter tennis") => {
    const fullTitle = `${appName} - ${pageTitle}`;
    const canonicalUrl = `${appUrl}${pagePath}`;

    return [
        <title key="title">{fullTitle}</title>,
        <meta key="desc" name="description" content={pageDescription || appDescription} />,
        <meta key="keywords" name="keywords" content={keywords} />,
        <link key="canonical" rel="canonical" href={canonicalUrl} />,

        /* Open Graph tags */
        <meta key="og:title" property="og:title" content={fullTitle} />,
        <meta key="og:description" property="og:description" content={pageDescription || appDescription} />,
        <meta key="og:image" property="og:image" content={appImage} />,
        <meta key="og:url" property="og:url" content={canonicalUrl} />,
        <meta key="og:type" property="og:type" content="website" />,
        <meta key="og:site_name" property="og:site_name" content={appName} />,

        /* Twitter Card tags */
        <meta key="twitter:card" name="twitter:card" content="summary_large_image" />,
        <meta key="twitter:title" name="twitter:title" content={fullTitle} />,
        <meta key="twitter:description" name="twitter:description" content={pageDescription || appDescription} />,
        <meta key="twitter:image" name="twitter:image" content={appImage} />,

        /* Additional tags */
        <meta key="app-name" name="application-name" content={appName} />,
        <meta key="apple-title" name="apple-mobile-web-app-title" content={appName} />
    ];
};

export const getJsonLdSchemas = () => {
    const schemas = [
        {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Inter Tennis",
            "operatingSystem": "iOS, Android",
            "applicationCategory": "SportsApplication",
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "ratingCount": "150"
            },
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "description": "AR-powered 3D tennis analytics platform for stroke analysis and match tracking.",
            "featureList": [
                "3D Ball Tracking",
                "Pose Motion Analysis",
                "AR Analytics Overlays",
                "Match Highlights Generation"
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Melilot Analytics SA",
            "url": "https://inter.tennis",
            "logo": "https://inter.tennis/Logo_rect_tilted_128.png",
            "sameAs": [
                "https://www.linkedin.com/company/inter-tennis-ai/",
                "https://apps.apple.com/app/inter-tennis/id6478206456",
                "https://play.google.com/store/apps/details?id=com.melilot.intertennis"
            ],
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Lausanne",
                "addressCountry": "Switzerland"
            }
        }
    ];

    return schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
            {JSON.stringify(schema)}
        </script>
    ));
};